import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import ElSchemaForm from 'el-schema-form'
import 'el-schema-form/dist/el-schema-form.css'
import VueLazyload from 'vue-lazyload'
import PermissionManager from './plugins/permission-manager' // 权限管理组件
import { VueMasonryPlugin } from 'vue-masonry'

import App from './App'
import router from './router'
import store from './store'
import { NODE_ENV } from '@com/config/env'

import i18n from '@/lang' // Internationalization
import '@/icons' // icon
import './permission' // permission control

import imageNotFound from '@/assets/common/404.jpg'
import spinner from '@/assets/common/spinner.svg'

import './styles/index.scss' // global css
import 'animate.css'

import * as filters from '@/filters' // global filters
import { createStorageTipsComponent } from '@com/components/storage-tips'

import ElButtonThrottle from '@com/directive/el-button-throttle'
import AutoTableColumn from '@com/pt-components/pt-table/AutoTableColumn'
import { advId, advName, advCC } from '@com/utils/adv-storage'

// 引入pt上报
import { ptLogs } from '@com/utils/report-logs/pt'

import PtSelectPro from '@com/pt-components/pt-select/pt-select-pro.vue'
import PtSelectGroupPro from '@com/pt-components/pt-select/pt-select-group-pro.vue'
import PageStayTracker from '@com/metrics-tracking/page-stay-tracker'
import { networkSpeed } from '@com/utils/network-speed'

import { sentryInit } from '@com/utils/sentry'

// 若不注册、el-schema-form在应用remote功能的时候，会自定销毁导致功能交互问题
Vue.component(PtSelectPro.name, PtSelectPro)
Vue.component(PtSelectGroupPro.name, PtSelectGroupPro)

// register global utility filters.
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

Vue.use(ElementUI, {
  size: 'small',
  i18n: (key, value) => i18n.t(key, value),
})

Vue.use(VueMasonryPlugin)
Vue.use(VueLazyload, {
  error: imageNotFound,
  loading: spinner,
})
Vue.use(PermissionManager)
Vue.use(ElSchemaForm)

Vue.directive('throttle', ElButtonThrottle)

// mock
// if (NODE_ENV === 'development') {
//   const mock = require('@/mock/index') // eslint-disable-line
// }

/* eslint-disable */
// 无法捕捉到异步错误
if (NODE_ENV === 'production') {
  Vue.config.errorHandler = function (err, vm, info) {
    console.error(`Error in ${info}: `, err, '\r\n 发生错误的 Vue 实例：', vm)
  }
}
/* eslint-enable */
Vue.config.warnHandler = (msg, vm, trace) => {
  if (!msg.includes('Avoid using Array as root value for reactive()')) {
    console.warn(msg, trace)
  }
}

Vue.config.productionTip = false

const StorageTips = createStorageTipsComponent(() => {
  return (
    store.state.assets.uploader.freeSize < 0 &&
    store.state.assets.uploader.freeSize !== -1
  )
})
const BalanceTips = createStorageTipsComponent(
  () => {
    return store.getters.isReachBalanceThreshold
  },
  {
    name: 'balance-tips',
    i18nKey: 'playTurbo.billing.balanceThresholdTips',
  },
)
Vue.component(StorageTips.name, StorageTips)
Vue.component(BalanceTips.name, BalanceTips)
Vue.component(AutoTableColumn.name, AutoTableColumn)

ptLogs.eachBefore((data) => {
  data.uid = store.state.user.info.id
  data.uid = data.uid ? data.uid : advId.get() || -1
  // 资源加载速度测算
  data.dls = networkSpeed.customSpeed // pt cdn速度
  data.gdls = networkSpeed.googleSpeed // google cdn速度
  data.cc = store.state.user.info.cc || advCC.get() || -1
  data.uname = store.state.user.info.username || advName.get() || -1
  data.adm_id = store.state.user.info.adm_id
  return data
})
let pageStayTracker = null
router.afterEach((to, from) => {
  console.log('router.afterEach', to, from)
  // 由于筛选条件的变化也会触发路由跳转，所以需要判断路由是否变化
  if (to.name !== from.name) {
    const pvAction = ptLogs.createAction()
    pvAction.log({
      e: 'pv',
      scene: to.name,
    })
    if (pageStayTracker) {
      pageStayTracker.destroy()
      pageStayTracker = null
    }
    pageStayTracker = new PageStayTracker({
      reportFunction: ({ duration, interactive }) => {
        pvAction.log({
          e: 'active',
          scene: to.name,
          d: duration,
          act: interactive,
        })
      },
    })
    pageStayTracker.startReporting()
  }
})

sentryInit({
  dsn: 'https://2e5b6c4b73c7e1adc01673432d4bf1ac@sentry.mintegral.com/6',
})

// eslint-disable-next-line
  new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App },
})

import '@com/pt-components/pt-table/autoWidth'
import '@pt/utils/dom-active'
